
























































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { orderUsersModule } from '../../Kanri/store/modules/OrderUsers'; // ストアモジュール
import { ITree } from '../../Kanri/store/dto/Organization'; // dto
import { IProcessHistories } from '../store/dto/ProcessHistories';
import { uketsukeManagementModule } from '../store/modules/UketsukeManger';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import { processHistoriesModule } from '../store/modules/ProcessHistories';
import { supervisingModule } from '@/store/modules/OperationSupervising';
// 定数
import { ApplicationProcessType} from '../fixed/ApplicationProcessType';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ProcessHistories extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [];  //初期表示展開
  private variableColNames: string[] = [];
  // 検索結果ヘッダの設定
  private headers = [{}];
  //ID設定変数
  private createElementId: string = '';
  private searchElementId: string = '';
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)

  private title: string = '';

  //通知内容表示用
  private tuchiNaiyou = '';
  private dialog = false;

  // 参照モードかどうか
  private isReadMode: boolean = true;

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '申請履歴';

    // 使用する可変項目の名前を指定(複数指定可)
    if (applicationFormModule.CHECK_TYPE_CONST) {
      this.createElementId = 'process_histories_const';
      this.searchElementId = 'process_histories_result_const';
      this.title = this.screenTitle + '（建設工事）';
    } else if (applicationFormModule.CHECK_TYPE_CONSUL) {
      this.createElementId = 'process_histories_consul';
      this.searchElementId = 'process_histories_result_consul';
      this.title = this.screenTitle + '（建設コンサル）';
    } else {
      this.createElementId = 'process_histories_goods';
      this.searchElementId = 'process_histories_result_goods';
      this.title = this.screenTitle + '（物品・役務）';
    }
    this.setVariablecolsState([this.createElementId]);

    // APIアクセス
    this.apiAccess(UketsukeConstants.PRO_HISTRIES_PATH + '/init/search', Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        const path = UketsukeConstants.PRO_HISTRIES_PATH + '/get/' + applicationFormModule.GET_APP_TYPE + '/' + processHistoriesModule.GET_TRADER_ID + '/' + ApplicationProcessType.HISTORY;
        const path1 = path + '/' + this.createElementId + '/' + this.searchElementId;
        this.apiAccess(path1, Constants.API_METHOD_GET, false, false)
        .then((result2) => {
          if (result2 === Constants.API_RESULT_SUCCES) {
            const path2 = UketsukeConstants.PRO_HISTRIES_PATH + '/search/' + applicationFormModule.GET_APP_TYPE + '/' + processHistoriesModule.GET_TRADER_ID + '/' + ApplicationProcessType.HISTORY;
            const path3 = path2 + '/' + this.searchElementId;
            this.apiAccess(path3, Constants.API_METHOD_POST, true, true)
            .then((result3) => {
              if (result3 === Constants.API_RESULT_SUCCES) {
                //検索結果.ボタンの設定
                // 使用する可変項目の設定（全て）
                this.setAllVariablecolsState();
                let panelIndex = 0;
                for (const variablecol of Object.keys(this.variablecols)) {
                  // パネル設定全オープン
                  this.searchPanel.push(panelIndex);
                  panelIndex++;
                  this.variableColNames.push(variablecol);
                }
                this.isReadMode = supervisingModule.IS_MODE_READ;
                this.headers.shift(); //先頭の空白列削除
                //検索結果.DBから展開
                for (const item of this.variablecols[this.searchElementId] ) {
                  this.headers.push({text: item.label,
                                    align: item.align,
                                    sortable: item.sortable,
                                    value: item.name,
                                    width: item.width,
                                   } );
                }
                this.headers.push(
                {text: '受理不受理時/通知内容', align: 'center', sortable: false, value: 'check', width: 90},
                );
              }
            });
          }
        });
      }
    });
  }

/**
 * 戻るボタン（戻るボタン押下時）
 */
  private returnPrevious() {
    if (supervisingModule.IS_ORDER_USER) {
      router.push({ name: processHistoriesModule.GET_TRANSITION_SOURCE_SCREEN});
    } else {
      router.push({ name: 'accepterMainMenu' });
    }
  }

/**
 * 受理/不受理時通知内容ボタン（受理/不受理時通知内容ボタン押下時）
 */
  private jyuriDialog(jyuriFujyuriNaiyou : string) {
    //ダイアログの表示内容を選択した申請状況に合わせる
    this.tuchiNaiyou = jyuriFujyuriNaiyou;
  }
}

